import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2f1d24a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagebox" }
const _hoisted_2 = { class: "topnav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OfficeFlow = _resolveComponent("OfficeFlow")!
  const _component_choose_approval = _resolveComponent("choose-approval")!
  const _component_choose_condition = _resolveComponent("choose-condition")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "enter",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
      }, "提交")
    ]),
    _createVNode(_component_OfficeFlow, {
      "add-nodes": _ctx.adddata,
      node: _ctx.cnode,
      onOnAdd: _ctx.onAdd,
      onOnChoose: _ctx.onChoose
    }, null, 8, ["add-nodes", "node", "onOnAdd", "onOnChoose"]),
    _createVNode(_component_Popup, {
      show: _ctx.popupshow,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.popupshow) = $event)),
      position: "right",
      style: {"height":"100%","width":"40%"}
    }, {
      default: _withCtx(() => [
        (_ctx.nodeData.type !== 'condition')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.popupshow )
                ? (_openBlock(), _createBlock(_component_choose_approval, {
                    key: 0,
                    conditionsData: _ctx.conditionsData,
                    nodeData: _ctx.nodeData,
                    onOnCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.popupshow = false)),
                    onOnEnter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.popupshow = false))
                  }, null, 8, ["conditionsData", "nodeData"]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.popupshow)
                ? (_openBlock(), _createBlock(_component_choose_condition, {
                    key: 0,
                    conditionsData: _ctx.conditionsData,
                    nodeData: _ctx.nodeData,
                    onOnCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.popupshow = false)),
                    onOnEnter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.popupshow = false))
                  }, null, 8, ["conditionsData", "nodeData"]))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}